export default __webpack_public_path__ + "static/ufclogo-892643ae9fb271310fdd3195ecd96c28.svg";